export class XsollaAnalyticsError extends Error {
  constructor(error: Error) {
    super(error.message);
    this.name = 'Xsolla Analytics Error';
  }
}
